// src/components/DietaryFilterUI.js
// Active-filter pill, "X items hidden" note and the "unverified" tag.
import React from 'react';
import { dietaryOption } from '../utils/dietary';

export function DietaryPill({ preference, onClear, isAr, large = false }) {
  if (!preference || preference === 'none') return null;
  const o = dietaryOption(preference);
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: large ? 12 : 8,
      padding: large ? '10px 18px' : '5px 10px', borderRadius: 20,
      background: 'var(--bg3)', border: '1px solid var(--accent)', color: 'var(--text)',
      fontSize: large ? 17 : 12, fontWeight: 600,
    }}>
      {o.icon} {isAr ? `فلتر ${o.ar} مفعّل` : `${o.en} filter active`}
      <button type="button" onClick={onClear} style={{
        background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text2)',
        borderRadius: 12, padding: large ? '4px 12px' : '1px 8px', fontSize: large ? 15 : 11, cursor: 'pointer',
      }}>✕ {isAr ? 'مسح' : 'Clear'}</button>
    </span>
  );
}

export function DietaryHiddenNote({ count, expanded, onToggle, isAr, large = false }) {
  if (!count) return null;
  return (
    <button type="button" onClick={onToggle} style={{
      display: 'block', width: '100%', textAlign: 'center', cursor: 'pointer',
      background: 'none', border: '1px dashed var(--border)', borderRadius: 10,
      color: 'var(--text2)', padding: large ? '16px' : '10px', fontSize: large ? 17 : 12,
    }}>
      {expanded
        ? (isAr ? 'إخفاء العناصر غير المؤكدة ▴' : 'Hide unverified items ▴')
        : (isAr ? `${count} عنصر مخفي — معلومات النظام الغذائي غير متوفرة` : `${count} item${count === 1 ? '' : 's'} hidden — dietary information not available`)}
    </button>
  );
}

export function UnverifiedTag({ isAr, large = false }) {
  return (
    <span style={{
      display: 'inline-block', marginInlineStart: 6, padding: large ? '3px 10px' : '1px 6px', borderRadius: 8,
      background: '#3d2e10', color: 'var(--accent)', fontSize: large ? 13 : 10, fontWeight: 700, verticalAlign: 'middle',
    }}>{isAr ? 'غير مؤكد' : 'Unverified'}</span>
  );
}
